import ConfiguratorPlayer from "components/configurator-v3/ConfiguratorPlayer"
import Page from "components/page/Page"
import QuickViewsPlayer from "components/quickviews/player/Player"
import StoryPlayer from "components/stories/player/StoryPlayer"
import { useConsole } from "contexts/Console"
import { Provider } from "contexts/Layout"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"
import { useUser } from "contexts/User"
import { Suspense } from "react"
import { Redirect, Route, Switch } from "react-router-dom"

export default function Layout({ initialState }) {
  const console = useConsole()
  const locale = useLocale()
  const navigation = useNavigation()
  const user = useUser()

  const { header, footer, query_param, footer_p13n, list_push_footer } = initialState[locale.current.codes.www]
  const footerSource = footer[0] ?? footer_p13n[0] ?? {}
  const pageFooter = Object.assign({}, footerSource, { listPush: list_push_footer })

  console.verbose("Layout(%o)", { header, footer, query_param, footer_p13n, list_push_footer })

  const _404 = process.browser && global.history.state?.state?.__status === 404

  return (
    <Provider value={{}}>
      <Switch>
        {_404 ? null : navigation.pages
          .filter(({ restrictions, geofencing }) => {
            if (restrictions && !restrictions?.includes?.(user?.countryCode?.toLowerCase?.())) return false
            if (geofencing && geofencing?.includes?.(user?.countryCode?.toLowerCase?.())) return false
            return true
          })
          .map(({ uid, url, exact, refresh, restrictions, geofencing, ...props }) => {
            const path = navigation.route(url)

            console.verbose("Layout:defineRoute(%o)", { url, path, exact })
            return (
              <Route
                key={refresh ? Date.now() : uid}
                path={path}
                exact={exact}
                render={() => {
                  return (
                    <>
                      <Suspense>
                        <StoryPlayer />
                        <QuickViewsPlayer />
                        <ConfiguratorPlayer initialState={initialState} />
                      </Suspense>
                      <Suspense>
                        <Page header={header} footer={pageFooter} uid={uid} {...props} url={url} initialState={initialState} />
                      </Suspense>
                    </>
                  )
                }}
              />
            )
          })}
        <Route
          key='catchall'
          path='*'
          render={() => {
            const { uid, url, exact, refresh, restrictions, geofencing, ...props } = navigation.pages.find(page => page.url === "/404") ?? {}

            return (
              <>
                <Suspense>
                  <StoryPlayer />
                  <QuickViewsPlayer />
                  <ConfiguratorPlayer initialState={initialState} />
                </Suspense>
                <Suspense>
                  <Page header={header} footer={pageFooter} uid={uid} {...props} url={url} initialState={initialState} />
                </Suspense>
              </>
            )
          }}
        />
      </Switch>
    </Provider>
  )
}
